module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "messageDialog",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header",
    class: [_vm.headerClass, {
      'block-header': _vm.title === 'Contrato bloqueado parcialmente'
    }]
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    class: {
      'block-title': _vm.title === 'Contrato bloqueado parcialmente'
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.type != 'BLANK') ? _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'BLANK') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    attrs: {
      "id": "BLANK-ACTIVE"
    }
  }, [_vm._v(_vm._s(_vm.message) + " "), _c('a', {
    style: ([_vm.colorTxtBlank != '#000000' ? {
      'color': _vm.colorTxtBlank
    } : {
      'color': _vm.colorTxtBlank
    }]),
    attrs: {
      "href": _vm.urlBlank,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.txtBlank))])])]) : _vm._e(), _vm._v(" "), (_vm.showContactText) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    staticClass: "contact-text",
    style: (_vm.title === 'Contrato bloqueado parcialmente' ? {
      marginTop: 'auto'
    } : {})
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/icon-question.svg")
    }
  }), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.title !== 'Contrato bloqueado parcialmente') ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.type == 'CLOSE') ? [_c('div', {
    staticClass: "wrapper-new-close"
  }, [_c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('OK')
      }
    }
  }, [_vm._v("\n              Fechar\n            ")])])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK' || _vm.type == 'BLANK') ? [_c('button', {
    staticClass: "btn btn-option-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('OK')
      }
    }
  }, [_vm._v("\n            OK\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK-CANCEL-ADHESION') ? [_c('div', {
    staticClass: "modal-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('OK')
      }
    }
  }, [_vm._v("\n              Quero cancelar\n            ")])])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK-CANCEL') ? [_c('button', {
    staticClass: "btn btn-option-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('CANCEL')
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-option-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('OK')
      }
    }
  }, [_vm._v("\n            OK\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'YES-NO') ? [_c('button', {
    staticClass: "btn btn-option-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('NO')
      }
    }
  }, [_vm._v("\n            Não\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.result('YES')
      }
    }
  }, [_vm._v("\n            Sim\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'DOWNLOAD') ? [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-error",
    attrs: {
      "href": _vm.urlPdf.url,
      "download": _vm.urlPdf.file
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "align-icon-left-white icon-pdf"
  }), _vm._v("\n            PDF\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-download-excel",
    attrs: {
      "href": _vm.urlExcel.url,
      "download": _vm.urlExcel.file
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "align-icon-left-white icon-xls"
  }), _vm._v("\n            EXCEL\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.urlJson.url,
      "download": _vm.urlJson.file
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "align-icon-left-white icon-json"
  }), _vm._v("\n            JSON\n          ")])])] : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n            Está com dúvidas? Chama no "), _c('a', {
    attrs: {
      "href": "https://wa.me/5511966192193",
      "target": "_blank"
    }
  }, [_vm._v("WhatsApp ")]), _vm._v("\n            ou ligue no "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" e fale com nossa Central de Atendimento.\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0f115cce!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message-dialog.vue
// module id = 2047
// module chunks = 1